import OrphanedGridResponse from "./Models/OrphanedGridResponse"
import { Filter, Sort } from "../GridRequest"
import { ObservableFromFetch } from "../ObservableFromFetch"

export function OrphanedGridGet(pageNumber: number, pageSize: number, sort: Sort, filters: Filter[]) {
  const requestBody = JSON.stringify({
    Filters: {
      DateCollected: filters.find(item => item.column === "DateCollected")?.values || [],
      DonorID: filters.find(item => item.column === "DonorID")?.values || [],
      FirstName: filters.find(item => item.column === "FirstName")?.values || [],
      LabAccountNumber: filters.find(item => item.column === "LabAccountNumber")?.values || [],
      LastName: filters.find(item => item.column === "LastName")?.values || [],
      CompanyName: filters.find(item => item.column === "CompanyName")?.values || [],
      Reason: filters.find(item => item.column === "Reason")?.values || [],
      ReferenceID: filters.find(item => item.column === "ReferenceID")?.values || [],
      TestType: filters.find(item => item.column === "TestType")?.values || [],
      ImportException: filters.find(item => item.column === "ImportException")?.values || [],
    },
    PageNumber: pageNumber,
    PageSize: pageSize,
    SortGrid: { SortColumn: sort.column, SortOrder: sort.order }
  })

  return ObservableFromFetch<OrphanedGridResponse>("WorkforceTrack/GetOrphanedRecords", requestBody)
}

export function OrphanedAccept(tests: { TestDetailID: number | string, AccountID?: number, TestDetailClinicalID: number | string }[]) {
  const requestBody = JSON.stringify(tests)

  return ObservableFromFetch<OrphanedGridResponse>("WorkforceTrack/ResolveOrphanedRecords", requestBody)
}

export function OrphanedDelete(tests: { TestDetailID: number | string, TestDetailClinicalID: number | string }[]) {
  const requestBody = JSON.stringify(tests)

  return ObservableFromFetch<OrphanedGridResponse>("WorkforceTrack/DeleteOrphanedRecords", requestBody)
}

export function OrphanedRecordsCount() {
  return ObservableFromFetch<number>("WorkforceTrack/GetOrphanedRecordsCount")
}
